const URL_CONSTANTS = {
  get_renewal_customers: "get_renewal_customers",
  create_order:"create_order",
  update_callback:"update_callback"

};

export { URL_CONSTANTS };
